import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'praece-react-bootstrap/lib/Tooltip';
import Overlay from 'praece-react-bootstrap/lib/Overlay';

// This is a component used to display help text
export default function HelpText({ show, container, children, placement, ...props }) {
  return (
    <Overlay placement={placement || 'top'} show={show} target={container} shouldUpdatePosition {...props} >
      <Tooltip id="input-help-text" className="input-help-text">
        {children}
      </Tooltip>
    </Overlay>
  );
}

HelpText.propTypes = {
  container: PropTypes.object,
  children: PropTypes.node,
  show: PropTypes.bool,
  placement: PropTypes.string
};
